import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Wraps any page that requires an authenticated agent session.
 * Whitelisted paths (login/signup/forgot-password/reset-password/verify-email)
 * never reach this component — they are mounted before the guard in App.js.
 * /admin is intentionally excluded too — it's protected by ADMIN_KEY only.
 */
export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', color: '#475569' }}>
        Loading…
      </div>
    );
  }
  if (!user) {
    const params = new URLSearchParams();
    if (location.pathname && location.pathname !== '/') {
      params.set('next', location.pathname + (location.search || ''));
    }
    const qs = params.toString();
    return <Navigate to={`/login${qs ? '?' + qs : ''}`} replace />;
  }
  return children;
}
